import { Button, Result } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import './Success.css';

const Success = () => {
    const history = useHistory();
    const handleBackToWebsiteClick = () => history.push('/my-account/');
    return (
        <div className="p-10 text-center">
            <Result
                status="success"
                title="Successfully Email Verification!"
                subTitle="Your Email Verfication was successfully, come back to main page!"
                extra={[
                    // eslint-disable-next-line react/jsx-key
                    <Button className="lg" type="primary" size="large" onClick={handleBackToWebsiteClick}>
                        Back to Website
                    </Button>,
                ]}
            />
        </div>
    );
};

export default Success;
